"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headShake = exports.shake = void 0;

var _index = require("../../../styles/index"); // -------------------------------------------
//   ANIMATIONS > SHAKE
// -------------------------------------------
// (((((((((( ~~~~~~~~~~ SHAKE ~~~~~~~~~~ )))))))))) //


var shake = {
  // ***** SHAKE ***** //
  '@keyframes shake': {
    'from, to': {
      transform: 'translate3d(0, 0, 0)'
    },
    '10%, 30%, 50%, 70%, 90%': {
      transform: (0, _index.replacePXinStringWithEM)('translate3d(-10px, 0, 0)')
    },
    '20%, 40%, 60%, 80%': {
      transform: (0, _index.replacePXinStringWithEM)('translate3d(10px, 0, 0)')
    }
  }
}; // (((((((((( ~~~~~~~~~~ HEAD SHAKE ~~~~~~~~~~ )))))))))) //

exports.shake = shake;
var headShake = {
  // ***** HEAD SHAKE ***** //
  '@keyframes headShake': {
    '0%': {
      transform: 'translateX(0)'
    },
    '6.5%': {
      transform: (0, _index.replacePXinStringWithEM)('translateX(-6px) rotateY(-9deg)')
    },
    '18.5%': {
      transform: (0, _index.replacePXinStringWithEM)('translateX(5px) rotateY(7deg)')
    },
    '31.5%': {
      transform: (0, _index.replacePXinStringWithEM)('translateX(-3px) rotateY(-5deg)')
    },
    '43.5%': {
      transform: (0, _index.replacePXinStringWithEM)('translateX(2px) rotateY(3deg)')
    },
    '50%': {
      transform: 'translateX(0)'
    }
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.headShake = headShake;